import { createIcon } from '../createIcon.tsx';

/** SINGLE person. The sibling `UsersIcon` is the TWO-person variant, so neither substitutes for the other. */
export const UserIcon = createIcon(
	'UserIcon',
	<>
		<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
		<circle cx="12" cy="7" r="4" />
	</>,
);
